export default "__VITE_ASSET__b87bb5c2__"